<template>
  <HeroSlider :slides="slides" :heightFirst="heightFirst" />
</template>

<script>
import HeroSlider from "../../components/HeroSlider/HeroSlider.vue";

export default {
  name: "app",
  components: {
    HeroSlider
  },
  data() {
    return {
      slides: JSON.parse(this.$options._parentVnode.data.props.slides),
      heightFirst: this.$options._parentVnode.data.props.heightFirst
    };
  }
};
</script>
